export const exterior_view04ImageOptions = {
  angle: 'exterior_view04',
  staticOptions: {
    BowSpirit: 1,
    HullTreatment: 1,
    TeakOnCoachroof: 1,
    Sprayhood: 1,
    MastAndBoom: 1,
    BoomCover: 1,
    PedestalOptions: 1
  },
  mattes: [
    {
      option: 'HullTreatment',
      dependency: null
    }
  ]
}



// WEBPACK FOOTER //
// ./src/XP44/views/exterior_view04.js